"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Captcha = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var reaptcha_1 = tslib_1.__importDefault(require("reaptcha"));
var Captcha_st_css_1 = require("./Captcha.st.css");
var filter_data_props_1 = require("../../utils/filter-data-props");
/**
 * Captcha
 */
var Captcha = /** @class */ (function (_super) {
    tslib_1.__extends(Captcha, _super);
    function Captcha() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.captchaRef = null;
        _this.state = {
            rendered: false,
            token: undefined,
        };
        /**
         * this will indicate the google component is loaded and ready to be displayed
         */
        _this.onLoad = function () {
            if (_this.props.onLoad) {
                _this.props.onLoad();
            }
        };
        /**
         * the user has successfully taken the captcha and we have the verification id
         * @param verificationString
         */
        _this.onVerified = function (verificationString) {
            _this.setState({ token: verificationString });
            if (_this.props.onVerify) {
                _this.props.onVerify(verificationString);
            }
        };
        /**
         * The user has taken the captcha challange however it has not been verified the page was not submitted in time
         * so we need to ask the user to retake the captcha challenge.
         */
        _this.onExpired = function () {
            _this.setState({ token: undefined });
            if (_this.props.onExpire) {
                _this.props.onExpire();
            }
        };
        /**
         * triggered when the inner captcha is actually rendered
         */
        _this.onRender = function () {
            _this.setState({ rendered: true });
            if (_this.props.onRender) {
                _this.props.onRender();
            }
        };
        /**
         * this method will pass the error to the registered error call back.
         */
        _this.onError = function () {
            if (_this.props.onError) {
                _this.props.onError();
            }
        };
        return _this;
    }
    /**
     * reload a new captcha from google
     */
    Captcha.prototype.resetCaptcha = function () {
        var _this = this;
        if (this.captchaRef) {
            this.captchaRef.reset();
        }
        this.setState({ token: undefined }, function () {
            if (_this.props.onReset) {
                _this.props.onReset();
            }
        });
    };
    /**
     * returns the verification token to the caller
     */
    Captcha.prototype.getVerificationToken = function () {
        return this.state.token;
    };
    /**
     * return true if the captcha challenge has been successfully taken
     */
    Captcha.prototype.isVerified = function () {
        return this.state.token !== undefined;
    };
    /**
     * we render the captcha.
     * we render a loader until we get a loaded indication from the captcha lib
     *
     */
    Captcha.prototype.render = function () {
        var _this = this;
        var _a = this.props, sitekey = _a.sitekey, loader = _a.loader, captchaType = _a.captchaType, size = _a.size, theme = _a.theme, lang = _a.lang, required = _a.required;
        return (React.createElement("div", tslib_1.__assign({ className: Captcha_st_css_1.st(Captcha_st_css_1.classes.root, { loaded: this.state.rendered }, this.props.className), "data-captcha-type": captchaType, "data-theme": theme, "data-lang": lang, "data-size": size }, filter_data_props_1.filterDataProps(this.props)),
            !this.state.rendered && (React.createElement("div", { className: Captcha_st_css_1.classes.loaderWrapper }, loader)),
            React.createElement("div", { className: Captcha_st_css_1.classes.captcha },
                React.createElement(reaptcha_1.default, { ref: function (e) { return (_this.captchaRef = e); }, sitekey: sitekey, captchaType: captchaType, size: size, theme: theme, hl: lang, onLoad: this.onLoad, onVerify: this.onVerified, onExpire: this.onExpired, onRender: this.onRender, onError: this.onError }),
                required && (React.createElement("input", { "data-hook": "required-field", className: Captcha_st_css_1.classes.requiredField, type: "checkbox", required: true, onChange: function () { }, checked: this.isVerified() })))));
    };
    Captcha.displayName = 'Captcha';
    return Captcha;
}(React.PureComponent));
exports.Captcha = Captcha;
//# sourceMappingURL=Captcha.js.map